export enum InstalmentFinancedBy {
  Issuer = 'ISSUER',
  IssuerMerchant = 'ISSUER_MERCHANT',
}
